import $ from '~/qwery';

export default class Viewport {
    constructor() {
        this._hidden = false;
        this.$siteInnerContainer = $(document.createElement('div'));
        this.$siteInnerContainer.attr('class', 'site-inner-container');
        while (document.body.childNodes.length) {
            this.$siteInnerContainer[0].appendChild(document.body.childNodes[0]);
        }
        this.$siteOuterContainer = $(document.createElement('div'));
        this.$siteOuterContainer.attr('class', 'site-outer-container');
        this.$siteOuterContainer.append(this.$siteInnerContainer);
        document.body.appendChild(this.$siteOuterContainer[0]);
    }

    showScrollbars() {
        this.$siteInnerContainer.css('width', '');
        this.$siteInnerContainer.css('height', '');
        this.$siteInnerContainer.css('margin-left', '');
        this.$siteInnerContainer.css('margin-top', '');
        this.$siteOuterContainer.css('width', '');
        this.$siteOuterContainer.css('height', '');
        $(document.body).css('min-width', '');
        $(document.body).css('overflow-y', '');
        window.scroll(this.noPopupPageXOffset(), this.noPopupPageYOffset());
        this._hidden = false;
    }

    hideScrollbars() {
        this._noPopupVertScrollbarWidth = window.innerWidth
            - document.documentElement.clientWidth;
        this._noPopupHorzScrollbarHeight = window.innerHeight
            - document.documentElement.clientHeight;
        this._noPopupSiteWidth = document.body.offsetWidth;
        this._noPopupSiteHeight = document.body.offsetHeight;
        this._noPopupPageXOffset = window.pageXOffset;
        this._noPopupPageYOffset = window.pageYOffset;
        $(document.body).css('min-width', 'auto');
        $(document.body).css('overflow-y', 'auto');
        this.$siteInnerContainer.css('margin-left', - this._noPopupPageXOffset + 'px');
        this.$siteInnerContainer.css('margin-top', - this._noPopupPageYOffset + 'px');
        this._hidden = true;
        this.updateExtents();
    }

    updateExtents() {
        this.$siteOuterContainer.css('width', window.innerWidth
            - this._noPopupVertScrollbarWidth + 'px');
        this.$siteOuterContainer.css('height', window.innerHeight
            - this._noPopupHorzScrollbarHeight + 'px');
        if (this.$siteInnerContainer[0].style.width
        && this.$siteOuterContainer[0].offsetWidth
            > this._noPopupSiteWidth - this.noPopupPageXOffset())
                this.$siteInnerContainer.css('width', '');
        else if ( ! this.$siteInnerContainer[0].style.width
        && this.$siteOuterContainer[0].offsetWidth
            < this._noPopupSiteWidth - this.noPopupPageXOffset())
                this.$siteInnerContainer.css('width', this._noPopupSiteWidth + 'px');
        if (this.$siteInnerContainer[0].style.height
        && this.$siteOuterContainer[0].offsetHeight
            > this._noPopupSiteHeight - this.noPopupPageYOffset())
                this.$siteInnerContainer.css('height', '');
        else if ( ! this.$siteInnerContainer[0].style.height
        && this.$siteOuterContainer[0].offsetHeight
            < this._noPopupSiteHeight - this.noPopupPageYOffset())
                this.$siteInnerContainer.css('height', this._noPopupSiteHeight + 'px');
    }


    noPopupScrollbarState() {
        return this.scrollbarsHidden()
            ? {vert: this._noPopupVertScrollbarWidth > 0,
                horz: this._noPopupHorzScrollbarHeight > 0}
            : {vert: window.innerHeight > document.documentElement.clientHeight,
                horz: window.innerWidth > document.documentElement.clientWidth};
    }

    noPopupPageXOffset() {
        return this.scrollbarsHidden() ? this._noPopupPageXOffset : window.pageXOffset;
    }

    noPopupPageYOffset() {
        return this.scrollbarsHidden() ? this._noPopupPageYOffset : window.pageYOffset;
    }

    noPopupClientWidth() {
        return this.scrollbarsHidden()
            ? this.$siteOuterContainer[0].offsetWidth
            : document.documentElement.clientWidth;
    }

    noPopupClientHeight() {
        return this.scrollbarsHidden()
            ? this.$siteOuterContainer[0].offsetHeight
            : document.documentElement.clientHeight;
    }

    scrollbarsHidden() {
        return this._hidden;
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/popup/viewport.js